import {
  IconAlertSquareRounded,
  IconArrowNarrowRight,
} from "@tabler/icons-react";
import React, { useEffect, useMemo, useState } from "react";
import CustomModal from "../../../components/modal/CustomModal";
import { useToast } from "../../../components/toast/toast";
import api from "../../../api";
import { DatePicker, Flex, Select } from "antd";
import { downloadTicketXLSX } from "../excel/LotteryTicketXLSX";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

export default function ReportTicket() {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lotteries, setLotteries] = useState([]);
  const [filters, setFilters] = useState({
    range: null,
    lotteryId: null,
  });

  const toast = useToast();

  const fetchLotteryList = async () => {
    const params = {
      limit: 1000,
    };
    const res = await api.get_lottery_list(params);

    if (res.status === 200) {
      setLotteries(res.data.data);
      // setPagination({
      //   ...pagination,
      //   current: page,
      //   total: res.data.pagination.total,
      // });
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
    //   setLoading(false);
  };

  useEffect(() => {
    if (showModal) {
      fetchLotteryList();
    }
  }, [showModal]);

  const closeModal = () => {
    setShowModal(false);
    setFilters({ range: null, lotteryId: undefined });
  };

  const options = useMemo(() => {
    return lotteries.map((l) => ({
      value: l.id,
      label: `${l.ticket_prefix} • ${l.title} • ${l.status}`,
      title: l.title,
      ticket_prefix: l.ticket_prefix,
      status: l.status,
    }));
  }, [lotteries]);

  // console.log("filter --->", filters);

  const handleDownload = async () => {
    setIsLoading(true);

    const payload = {
      lotteryId: filters?.lotteryId || null,
      range: filters?.range
        ? [
            dayjs(filters.range[0]).startOf("day").toISOString(),
            dayjs(filters.range[1]).endOf("day").toISOString(),
          ]
        : null,
    };

    // console.log(payload);
    const res = await api.report_lottery_tickets(payload);
    // console.log("report_lottery_ticket res --->", res);
    if (res?.status === 200) {
      await downloadTicketXLSX(res.data);
      toast("Тасалбарын тайлан татагдлаа", "success");
    } else {
      toast(res.data?.message || "Алдаа гарлаа", "error");
    }
    setIsLoading(false);
    closeModal();
  };

  return (
    <div>
      <div
        style={{
          background: "#f5f5f5",
          padding: "24px",
          borderRadius: 8,
          border: "1px solid #e0e0e0",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          transition: "0.2s",
        }}
        onClick={() => setShowModal(true)}
        role="button"
        tabIndex={0}
      >
        <h4 style={{ margin: 0 }}>Тасалбарын тайлан татах</h4>
        <IconArrowNarrowRight size={22} />
      </div>

      <CustomModal
        open={showModal}
        title={"Тасалбарын тайлан татах"}
        onCancel={closeModal}
        onOk={handleDownload}
        disabled={
          !isLoading && (filters?.lotteryId || filters?.range) ? false : true
        }
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Flex
            style={{
              backgroundColor: "#fff6cc",
              padding: "15px",
              borderRadius: "4px",
            }}
            align="center"
            gap={"10px"}
          >
            <IconAlertSquareRounded
              strokeWidth={1.5}
              color="#5f5c73"
              style={{
                width: "20px",
                height: "20px",
                padding: 0,
                margin: 0,
                flexShrink: 0,
              }}
            />

            <p style={{ color: "#5f5c73", textAlign: "justify" }}>
              Тайлан татахдаа{" "}
              <span style={{ color: "#000", fontWeight: 600 }}>“Хугацаа”</span>,{" "}
              <span style={{ color: "#000", fontWeight: 600 }}>“Сугалаа”</span>{" "}
              эсвэл эдгээрийг{" "}
              <span style={{ color: "#000", fontWeight: 600 }}>
                хамтад нь сонгож
              </span>{" "}
              тайлан гаргах боломжтой.
            </p>
          </Flex>
          <div>
            <p style={{ fontSize: "13px" }}>Хугацаагаар шүүх</p>
            <RangePicker
              style={{ width: "100%", height: 40 }}
              value={filters.range}
              onChange={(val) => setFilters((p) => ({ ...p, range: val }))}
              allowClear
              placeholder={["Эхлэх хугацаа", "Дуусах хугацаа"]}
              // optional: ирээдүйн огноо хорих
              // disabledDate={(current) => current && current > dayjs().endOf("day")}
            />
          </div>

          <div>
            <p style={{ fontSize: "13px" }}>Сугалаа сонгох</p>
            <Select
              style={{ width: "100%", height: 40 }}
              placeholder="Сугалаа сонгох (заавал биш)"
              loading={isLoading}
              allowClear
              showSearch
              options={options}
              value={filters.lotteryId}
              onChange={(val) => setFilters((p) => ({ ...p, lotteryId: val }))}
              optionFilterProp="label"
              filterOption={(input, option) => {
                const label = (option?.label || "").toLowerCase();
                return label.includes((input || "").toLowerCase());
              }}
            />
          </div>
        </div>
      </CustomModal>
    </div>
  );
}
